export default "__VITE_ASSET__ClmE_Hv5__"